// ──────────────────────────────────────────────────────────────────────────
//  Capture UTM params, persist them, and push a single GA / GTM event
// ──────────────────────────────────────────────────────────────────────────
(() => {
    const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_content'];
    const searchParams = new URLSearchParams(location.search);
    const utmValues = {};

    UTM_KEYS.forEach(key => {
        const value = searchParams.get(key) ?? localStorage.getItem(key);
        if (value !== null) {
            localStorage.setItem(key, value);
            utmValues[key] = value;
        }
    });


    if (Object.keys(utmValues).length) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event:           'qrCodeVisit',
            pageTitle:       document.title || 'No title',
            connectPartner:  utmValues.utm_source  || '',
            campaignSource:  utmValues.utm_medium  || '',
            connectAssociate: utmValues.utm_content || ''
        });
    }
})();
